import React from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-174">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-175" />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" data-id="element-176">
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex items-center justify-between" data-id="element-177">
          <h2 className="text-2xl font-serif font-medium text-[#3a3a3a]" data-id="element-178">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition" data-id="element-179">
            <X size={24} className="text-[#5a5a5a]" data-id="element-180" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-100px)]" data-id="element-181">
          {children}
        </div>
      </div>
    </div>;
};
export default Modal;